import { useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import LoadingDash from './LoadingDash'

const FsFullPageLoader = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <div
      style={{
        width: 'calc(100% - 70px)',
        height: 'calc(100vh - 78px)',
        position: 'fixed',
        top: 78,
        left: 70,
        zIndex: 1800,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor:
          theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, .8)' : 'rgba(255, 255, 255, .8)',
      }}
    >
      <LoadingDash title={t('loading')} />
    </div>
  )
}

export default FsFullPageLoader
